var exports = {
  "EY": "Text__Mtp4Qf",
  "UE": "Text_1__cE2PT3",
  "Nl": "Text_2__toSyiB",
};

module.exports = exports;
